export const DownloadsActions = {
  async updateDownloadRequest ({ commit }, request) {
    commit('updateDownloadRequest', request)
  },

  async removeDownloadRequest ({ commit }, id) {
    commit('removeDownloadRequest', id)
  },
}
